const PriceBuildUpStatus = {
  Active: "active",
  Scheduled: "scheduled",
  Expired: "expired",
  Cancelled: "cancelled",
};

export default PriceBuildUpStatus;
